import React, {Component, Fragment } from "react";
import { Button, FormGroup, Input, Label, Table, Media } from "reactstrap";
import { inject, observer } from 'mobx-react';
import Avatar from "../../elements/avatar";
import classnames from "classnames";
import "../../../assets/scss/pages/common.scss";

import profileImg from "../../../assets/img/profile/placeholder.svg";

@inject('sessionStore')
@observer
class General extends Component {

  constructor(props) {
    super(props);
    this.state={
      avatarEditVisible: false,
    }
  }

  toggleSlider = (bool) => {
    this.setState({
      avatarEditVisible: bool
    })
  }

  componentDidMount = () => {
    let { sessionStore } = this.props;
    let { authUser } = sessionStore;
  }

  onSaveImage = (url) => {
    let { sessionStore } = this.props;
    sessionStore.setAvatar(url);
  }

  render() {
    let { sessionStore } = this.props;
    let { firstName, lastName, title } = sessionStore.authUser;

    return(
      <Fragment>
        <div className="d-flex justify-content-start align-items-center mb-3">
          <Media className="mb-2">
            <Media className="mt-10 mr-2 my-25" left href="#">
              <Media
                className="rounded"
                object
                src={profileImg}
                alt="user profile image"
                height="110"
                width="95"
              />
            </Media>
            <Media className="mt-2" body>
              <Media className="font-medium-1 text-bold-600" tag="p" heading>
                {title + " " + firstName + " " + lastName}
              </Media>
              <div className="d-flex flex-wrap">
                <Button
                  onClick={() => { this.toggleSlider(true) }}
                  className="mr-50 cursor-pointer"
                  color="primary"
                  outline>
                  Change Avatar
                  </Button>
                <Button color="flat-danger">Remove Avatar</Button>
              </div>
              <p className="text-muted mt-50">
                <small>Allowed JPG, GIF or PNG. Max size of 800kB</small>
              </p>
            </Media>
          </Media>

        </div>
        <div>
          <FormGroup>
            <Label htmlFor="username">User Name</Label>
            <Input
              type="text"
              id="username"
              onChange={()=>{}}
              value="john_01"
              placeholder="User Name"
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="name">Name</Label>
            <Input
              type="text"
              id="name"
              onChange={() => { }}
              value="John Doe"
              placeholder="Enter Name"
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="email">Email</Label>
            <Input
              type="email"
              id="email" 
              onChange={() => { }}
              value="johndoe@sample.com"
              placeholder="Enter Email"
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="company">Company</Label>
            <Input
              type="text"
              id="company"
              onChange={() => { }}
              placeholder="Company"
            />
          </FormGroup>
        </div>
        <div>
          <Button
            className="btn mr-1"
            color="primary">
            Save Changes
          </Button>
          <Button
            className="btn"
            outline
            color="danger">
            Cancel
          </Button>
        </div>
        <div className="animation-slider">
          {
            this.state.avatarEditVisible
              ? <Avatar
                show={this.state.avatarEditVisible}
                onSave={this.onSaveImage}
                toggleSliderVisibility={() => this.toggleSlider(false)}
              />
              : null
          }
          <div
            className={classnames("animation-slider-overlay", {
              show: this.state.avatarEditVisible
            })}
            onClick={() => this.toggleSlider(false)}
          />
        </div>  
      </Fragment>
    );
  }
}

const styles = {
  imageDiv: {
    height: "80px",
    width: "80px",
    overflow: "hidden",
    borderRadius: "50%",
    // border: "2px solid #cacaca"
  },
  image: {
    height: "100%",
    width: "100%",
    objectFit: "contain",
    objectPosition: "center"
  },
  textMuted:{
    fontSize: "14px",
    color: "#cacaca"
  } 
}

export default General;